import {BiLock} from "react-icons/bi";
import {motion} from "framer-motion";
import {useStateValue} from "../../context/StateProvider";
import React, {useEffect, useState} from "react";
import {withYMaps} from "@pbe/react-yandex-maps";
import {verifyPhone} from "../../api/cart";
import CheckoutFooter from "./footer";
import Select from 'react-select';
import {toast} from "react-toastify";

const validateInput = (value: string | null, type: string) => {
    if (value == null || value == "") {
        return false
    }
    if (type == "number") {
        return ((value != null) &&
            (value !== '') &&
            !isNaN(Number(value.toString())));
    } else {
        return true
    }
}

const getTimeInZone = (timeZone: string) => {
    const formatter = new Intl.DateTimeFormat("en-GB", {
        timeZone,
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    });

    const parts = formatter.formatToParts(new Date());

    const hour = Number(parts.find(p => p.type === "hour")?.value);
    const minute = Number(parts.find(p => p.type === "minute")?.value);

    return {hour, minute};
};

const formatRussianPhone = (value: string) => {
    // Оставляем только цифры
    let digits = value.replace(/\D/g, "");

    // Если пользователь начал с 8 или 7
    if (digits.startsWith("8")) {
        digits = "7" + digits.slice(1);
    }

    if (!digits.startsWith("7")) {
        digits = "7" + digits;
    }

    digits = digits.substring(0, 11);

    let result = "+7";

    if (digits.length > 1) {
        result += " (" + digits.substring(1, 4);
    }

    if (digits.length >= 4) {
        result += ")";
    }

    if (digits.length > 4) {
        result += " " + digits.substring(4, 7);
    }

    if (digits.length > 7) {
        result += "-" + digits.substring(7, 9);
    }

    if (digits.length > 9) {
        result += "-" + digits.substring(9, 11);
    }

    return result;
};

const processOrder = (dispatch: any, formData: any, checkPhoneState: (state: boolean) => {}) => {
    formData.phone = formData.phone.replace(/\D/g, "");
    dispatch({
        type: "SET_USER_CART_INFO",
        userCartInfo: formData,
    });
    console.log(formData)
    if (formData.orderType == "delivery") {
        if (!validateInput(formData.address, "string")) {
            toast.warn("Введите адрес");
            return
        }
        if (!validateInput(formData.apartments, "number")) {
            toast.warn("Введите номер квартиры");
            return
        }
        if (!validateInput(formData.floor, "number")) {
            toast.warn("Введите номер этажа");
            return
        }
        if (!validateInput(formData.entrance, "number")) {
            toast.warn("Введите номер подъезда");
            return
        }
        if (!validateInput(formData.intercom, "string")) {
            toast.warn("Укажите домофон");
            return
        }
        if (!validateInput(formData.paymentMethod, "string")) {
            toast.warn("Укажите вариант оплаты");
            return
        }
    }

    if (!/^7\d{10}$/.test(formData.phone)) {
        toast.warn("Введите корректный номер телефона");
        return;
    }
    if (!validateInput(formData.username, "string")) {
        toast.warn("Введите корректное имя");
        return
    }
    if (!formData.agreement) {
        toast.warn("Необходимо ознакомиться с политикой конфиденциальности и публичной офертой");
        return
    }
    const data = {
        phone: formData.phone,
        type: "telegram"
    }
    verifyPhone(data, checkPhoneState)
    localStorage.setItem('lastSendMethod', "sms");
    checkPhoneState(true)
};

const MapSuggestComponent = (props: any) => {
    const [{}, dispatch] = useStateValue()
    const {ymaps} = props;

    React.useEffect(() => {
        const suggestView = new ymaps.SuggestView("suggest");
    }, [ymaps.SuggestView]);

    return <input
        id="suggest"
        type="text"
        className="form-control block w-full px-4 py-2  text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-buttonColor focus:outline-none"
        placeholder="Адрес"
        onChange={(e) => {
            console.log(e.target.value)
        }}
    />;
}

const Body = ({checkPhoneState}: { checkPhoneState: any }) => {
    const [{userCartInfo}, dispatch] = useStateValue()
    const SuggestComponent = React.useMemo(() => {
        return withYMaps(MapSuggestComponent, true, [
            "SuggestView"
        ]);
    }, []);

    const intercomOptions = [
        {value: "work", label: "Работает"},
        {value: "not_work", label: "Не работает"},
    ];

    const paymentMethodOptions = [
        {value: "payment_uniteller", label: "Картой"},
    ];

    const [address, setAddress] = useState("");
    const [apartments, setApartments] = useState("");
    const [entrance, setEntrance] = useState("");
    const [intercom, setIntercom] = useState<{ value: string; label: string; } | null>(null)
    const [floor, setFloor] = useState("");
    const [comment, setComment] = useState("");
    const [paymentMethod, setPaymentMethod] = useState<{ value: string; label: string; } | null>(null)
    const [orderType, setOrderType] = useState("delivery");
    const [phone, setPhone] = useState("");
    const [username, setUsername] = useState("");
    const [agreement, setAgreement] = useState<boolean>(false);
    const [activeTabIndex, setActiveTabIndex] = useState(0);

    useEffect(() => {
        if (userCartInfo.orderType !== "pickup") {
            setAddress(userCartInfo.address)
            setApartments(userCartInfo.apartments)
            setEntrance(userCartInfo.entrance)
            setIntercom(userCartInfo.intercom)
            setPaymentMethod(userCartInfo.paymentMethod)
            setFloor(userCartInfo.floor)
            setComment(userCartInfo.comment)
        }
        setPhone(formatRussianPhone(userCartInfo.phone))
        setUsername(userCartInfo.username)
        setAgreement(userCartInfo.agreement)
        setActiveTabIndex(userCartInfo.orderType == "pickup" ? 1 : 0)
        setOrderType(userCartInfo.orderType)
    }, [userCartInfo, dispatch]);

    const tabsData = [
        {
            label: "Доставка",
            name: "delivery",
            content: <div className="min-h-[50vh] mt-5">
                <div className="p-2">
                    <input
                        type="text"
                        className="form-control w-full px-4 py-2  text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-buttonColor focus:outline-none"
                        placeholder="Адрес"
                        value={address}
                        onChange={(e) => {
                            setAddress(e.target.value)
                        }}
                    />
                    {/*<YMaps*/}
                    {/*    enterprise={false}*/}
                    {/*    query={{*/}
                    {/*        apikey: "6e347aaa-d146-435d-84c0-9b0002d554da",*/}
                    {/*        suggest_apikey: "677385c4-2a33-4510-8e8a-0c9fdd9cced7",*/}
                    {/*        lang: "ru_RU"*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    <SuggestComponent/>*/}
                    {/*</YMaps>*/}
                </div>
                <div className="flow-root">
                    <div className="w-1/3 p-2 float-left">
                        <input
                            type="number"
                            className="form-control w-full px-4 py-2  text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-buttonColor focus:outline-none"
                            placeholder="Квартира"
                            onChange={(e) => {
                                setApartments(e.target.value)
                            }}
                            value={apartments}
                        />
                    </div>
                    <div className="w-1/3 p-2 float-right">
                        <input
                            type="number"
                            className="form-control block w-full px-4 py-2  text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-buttonColor focus:outline-none"
                            placeholder="Подъезд"
                            onChange={(e) => {
                                setEntrance(e.target.value)
                            }}
                            value={entrance}
                        />
                    </div>
                    <div className="w-1/3 p-2 float-right">
                        <input
                            type="number"
                            className="form-control block w-full px-4 py-2  text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-buttonColor focus:outline-none"
                            placeholder="Этаж"
                            onChange={(e) => {
                                setFloor(e.target.value)
                            }}
                            value={floor}
                        />
                    </div>
                </div>
                <div className="flow-root">
                    <div className="w-2/4 p-2 float-left">
                        <Select
                            className="block w-full text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-buttonColor focus:outline-none"
                            value={intercomOptions.find(item => intercom ? item.value === intercom.value : null)}
                            placeholder="Домофон"
                            onChange={setIntercom}
                            options={intercomOptions}
                        />
                    </div>
                    <div className="w-2/4 p-2 float-right">
                        <Select
                            className="block w-full text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-buttonColor focus:outline-none"
                            value={paymentMethodOptions.find(item => paymentMethod ? item.value === paymentMethod.value : null)}
                            placeholder="Оплата"
                            onChange={setPaymentMethod}
                            options={paymentMethodOptions}
                        />
                    </div>
                </div>
                <div className="p-2">
                    <input
                        type="text"
                        className="form-control block w-full px-4 py-2  text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-buttonColor focus:outline-none"
                        placeholder="Комментарий для курьера"
                        onChange={(e) => {
                            setComment(e.target.value)
                        }}
                        value={comment}
                    />
                </div>

                <div className="m-2 flex border border-gray-300 rounded-md">
                    <input
                        type="tel"
                        inputMode="numeric"
                        autoComplete="tel"
                        className="form-control block w-full px-4 py-2 text-gray-700 bg-white border border-solid border-gray-300 rounded focus:border-buttonColor focus:outline-none"
                        placeholder="+7 (___) ___-__-__"
                        value={phone}
                        onChange={(e) => {
                            setPhone(formatRussianPhone(e.target.value));
                        }}
                    />
                </div>

                <div className="p-2">
                    <input
                        type="text"
                        className="form-control block w-full px-4 py-2  text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-buttonColor focus:outline-none"
                        placeholder="Имя"
                        onChange={(e) => {
                            setUsername(e.target.value)
                        }}
                        value={username}
                    />
                </div>

                <div className="p-2 flex items-center space-x-2 cursor-pointer">
                    <input
                        type="checkbox"
                        className="flex form-control block  text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-buttonColor focus:outline-none"
                        onChange={(e) => {
                            setAgreement(e.target.checked)
                        }}
                        checked={agreement}
                    />
                    <span>
                        <p className="text-sm leading-6 text-gray-500">
                        Я соглашаюсь с <a
                            className="font-semibold text-buttonColor" href="/privacy_policy">политикой
                        конфиденциальности</a>
                        , а так же ознакомлен с <a
                            className="font-semibold text-buttonColor" href="/public_offer">публичной офертой</a>.
                        </p>
                    </span>
                </div>

                <div className="w-full flex items-center justify-center mt-4">
                    <motion.button
                        onClick={() => processOrder(dispatch, {
                            address: address,
                            apartments: apartments,
                            entrance: entrance,
                            intercom: intercom,
                            floor: floor,
                            comment: comment,
                            paymentMethod: paymentMethod,
                            orderType: orderType,
                            phone: phone,
                            username: username,
                            agreement: agreement
                        }, checkPhoneState)}
                        whileTap={{scale: 0.95}}
                        className="flex items-center justify-center gap-2 w-[90%] p-2 rounded-full bg-gradient-to-tr from-buttonColor to-buttonColor hover:from-buttonColor hover:to-buttonColor transition-all duration-75 ease-in-out text-gray-50 text-lg my-2 hover:shadow-lg"
                    >
                        <BiLock className=""/>
                        Заказать
                    </motion.button>
                </div>
            </div>
        }
    ];

    return (
        <div className="w-full h-full bg-cartBg flex flex-col">
            <div>
                <div className="flex border-b">
                    {tabsData.map((tab, idx) => {
                        return (
                            <button
                                key={idx}
                                className={`mx-1 py-2 w-1/2 border-b-4 transition-colors duration-300 textColor ${
                                    idx === activeTabIndex
                                        ? "text-buttonColor"
                                        : "text-lightGray border-transparent hover:text-buttonColor"
                                }`}
                                onClick={() => {
                                    setOrderType(tab.name);
                                    setActiveTabIndex(idx)
                                }}>
                                {tab.label}
                            </button>
                        );
                    })}
                </div>
                <div className="py-4">
                    <p>{tabsData[activeTabIndex].content}</p>
                </div>
            </div>
            <CheckoutFooter/>
        </div>
    );
};

export default Body